import { useReduxState } from 'hooks';
import { defaultBlockData } from 'components/editor/blocks';
import { EditorBlockChoiceTasks } from 'components/editor/blocks/choiceTasks';

import type { BlockMultipleChoice } from 'shared-types';
import type { BlockProps } from 'components/editor/blocks/EditorBlock';
import type { BlockChoiceTasksStateProps } from '../choiceTasks/EditorBlockChoiceTasks';

const EditorBlockSingleChoice = ({
  blockId,
  data,
  isAIPreview,
  isPreview,
  languageVersion,
  updateData,
  ...stateProps
}: BlockProps<BlockMultipleChoice> & BlockChoiceTasksStateProps) => {
  const { messages } = useReduxState();

  return (
    <EditorBlockChoiceTasks
      blockId={blockId}
      blockName={messages.blocksSingleChoice}
      data={data}
      defaultPointsWeight={defaultBlockData.singlechoice.pointsWeight}
      isAIPreview={isAIPreview}
      isPreview={isPreview}
      languageVersion={languageVersion}
      taskQuestionPlaceHolder={
        messages.editorBlockSingleChoiceQuestionPlaceholder
      }
      updateData={updateData}
      {...stateProps}
    />
  );
};

export default EditorBlockSingleChoice;
